'use client'

import React, { createContext, useContext } from 'react'

export type ImageSettings = {
  /** 'blur' = placeholder atual; 'gray' = fundo cinza + fade-in no carregamento. */
  loadingBackground: 'blur' | 'gray'
  /** URL para onde a imagem cai em caso de erro de carregamento (`onError`). Vazio = sem swap. */
  fallbackUrl: string
  /**
   * O que mostrar quando o post NÃO tem imagem de destaque:
   * 'image' = a imagem padrão (`fallbackUrl`); 'gray' = só o fundo cinza do contentor.
   */
  placeholderMode: 'image' | 'gray'
}

const DEFAULT_IMAGE_SETTINGS: ImageSettings = {
  loadingBackground: 'blur',
  fallbackUrl: '',
  placeholderMode: 'image',
}

const ImageSettingsContext = createContext<ImageSettings>(DEFAULT_IMAGE_SETTINGS)

/**
 * Provider hidratado no root layout (server) a partir do global «Identidade do site → Imagens».
 * Permite que os componentes client (ImageMedia) leiam o modo de loading + a imagem fallback
 * sem prop drilling. Sem provider → defaults (comportamento atual, zero-regressão).
 */
export function ImageSettingsProvider({
  value,
  children,
}: {
  value: ImageSettings
  children: React.ReactNode
}) {
  return <ImageSettingsContext.Provider value={value}>{children}</ImageSettingsContext.Provider>
}

export function useImageSettings(): ImageSettings {
  return useContext(ImageSettingsContext)
}
